
export const to_getFriendlyName = (templateOptions) => (
    templateOptions?.options?.find((o) => o.devKey === "ui_friendly_product_name")?.value
);

